import { useCallback } from 'react';

import { OneTimeModal } from '@backrs_ui/grow-ui/src/components/OneTimeModal/OneTimeModal';
import { useAutoModalHold } from '@backrs_ui/grow-ui/src/components/ProfileCompletionModal/useProfileCompletionModal';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  useGetCurrentOneTimeModalQuery,
  useGetGettingStartedModalStateQuery,
  useMarkOneTimeModalSeenMutation,
} from '@backrs_ui/grow-ui/src/redux/oneTimeModal/oneTimeModal.api';

export const HomePageContainer = () => {
  const user = useAppSelector((state) => state.user.user);

  const { data: gettingStartedState, isLoading: isLoadingGettingStarted } =
    useGetGettingStartedModalStateQuery(undefined);
  const autoModalHold = useAutoModalHold();
  const shouldShowOneTimeModal = !!gettingStartedState?.seen && !autoModalHold;

  const { data: currentModal, isLoading: isLoadingModal } = useGetCurrentOneTimeModalQuery(
    undefined,
    { skip: !shouldShowOneTimeModal },
  );
  const [markSeen] = useMarkOneTimeModalSeenMutation();

  const handleModalClose = useCallback(async () => {
    if (currentModal) {
      await markSeen(currentModal.id);
    }
  }, [currentModal, markSeen]);

  if (
    !user ||
    isLoadingGettingStarted ||
    !shouldShowOneTimeModal ||
    isLoadingModal ||
    !currentModal
  ) {
    return null;
  }

  return <OneTimeModal open modal={currentModal} onClose={handleModalClose} />;
};
